import { useEffect, useState } from "react";

/** true zolang het scherm smaller is dan `px` (telefoon staand = 640). */
export function useSmal(px = 640) {
  const q = `(max-width: ${px}px)`;
  const [smal, setSmal] = useState(() => typeof window !== "undefined" && window.matchMedia(q).matches);
  useEffect(() => {
    const mq = window.matchMedia(q);
    const h = () => setSmal(mq.matches);
    h();
    mq.addEventListener("change", h);
    return () => mq.removeEventListener("change", h);
  }, [q]);
  return smal;
}
